import React from 'react'

import FieldFormula from "../formula"
import HintPopover from "../../../../gd-ui/hint-popover/hint-popover"
import ErrorBoundary from "../../../../error-boundary"

type FieldFormulaViewProps = {
    className?  : string

    field       : FieldFormula
    model       : any

    options?    : any
    onClick?    : onClick
}

export default function FieldFormula_ViewProperty(props: FieldFormulaViewProps) {
    const prefix = _.get(props.field.components, 'ValuePrefix', null)
    const displayValue = props.field.getDisplayValue(props.field.calculateValue(props.model))

    const classes = Classes('ui5-property', props.className)

    return (
        <ErrorBoundary>
            <div className={classes}>
                <div className={Classes("ui5-ico-12 m-r-5", props.field.icon)}/>
                {prefix}{displayValue}
                <HintPopover hint={props.field.label}/>
            </div>
        </ErrorBoundary>
    )
}
